module.exports = __webpack_public_path__ + "static/media/live14_06_2019.5b7a3829.jpg";